<template>
    <!-- blog area start -->
    <div class="blog-area pd-top-120 pd-bottom-120">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-9">
                    <div class="section-title text-center">
                        <h5 class="sub-title double-line">Blog Post</h5>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="single-blog-inner">
                        <div class="thumb">
                            <img src="assets/img/blog/1.webp" alt="img">
                        </div>
                        <div class="details">
                            <h2><a href="#">Data Exchange</a></h2>
                            <ul class="blog-meta">
                                <li><i class="far fa-user"></i> By Admin</li>
                                <li><i class="far fa-calendar-alt"></i> 25 May 2021</li>
                                <li><i class="far fa-comment-dots"></i> 22 Comment</li>
                                <li><i class="far fa-folder-open"></i> It Solution</li>
                            </ul>
                            <p>actually choosing a strategy entails making decisions that explicitly cut off possibilities and options. An executive may well fear that getting those decisions wrong</p>
                            <a class="read-more-text" href="#">Read More <i class="fa fa-caret-right"></i></a>
                        </div>
                    </div>
                    <div class="single-blog-inner">
                        <div class="thumb">
                            <img src="assets/img/blog/2.webp" alt="img">
                            <a class="video-play-btn video-play-btn-base" href="https://www.youtube.com/embed/Wimkqo8gDZ0" data-effect="mfp-zoom-in"><i class="fa fa-play"></i></a>
                        </div>
                        <div class="details">
                            <h2><a href="#">IT Consultancy</a></h2>
                            <ul class="blog-meta">
                                <li><i class="far fa-user"></i> By Admin</li>
                                <li><i class="far fa-calendar-alt"></i> 25 May 2021</li>
                                <li><i class="far fa-comment-dots"></i> 22 Comment</li>
                                <li><i class="far fa-folder-open"></i> It Solution</li>
                            </ul>
                            <p>actually choosing a strategy entails making decisions that explicitly cut off possibilities and options. An executive may well fear that getting those decisions wrong</p>
                            <a class="read-more-text" href="#">Read More <i class="fa fa-caret-right"></i></a>
                        </div>
                    </div>
                    <div class="single-blog-inner">
                        <div class="blog-thumb-slider slider-control-round owl-carousel">
                            <div class="item">
                                <img src="assets/img/blog/3.webp" alt="img">
                            </div>
                            <div class="item">
                                <img src="assets/img/blog/1.webp" alt="img">
                            </div>
                        </div>
                        <div class="details">
                            <h2><a href="#">Data Security</a></h2>
                            <ul class="blog-meta">
                                <li><i class="far fa-user"></i> By Admin</li>
                                <li><i class="far fa-calendar-alt"></i> 25 May 2021</li>
                                <li><i class="far fa-comment-dots"></i> 22 Comment</li>
                                <li><i class="far fa-folder-open"></i> It Solution</li>
                            </ul>
                            <p>actually choosing a strategy entails making decisions that explicitly cut off possibilities and options. An executive may well fear that getting those decisions wrong</p>
                            <a class="read-more-text" href="#">Read More <i class="fa fa-caret-right"></i></a>
                        </div>
                    </div>
                    <div class="pagination">
                        <a class="prev page-numbers" href="#"><i class="fa fa-angle-left"></i></a>
                        <span class="page-numbers current">1</span>
                        <a class="next page-numbers" href="#"><i class="fa fa-angle-right"></i></a>
                    </div>
                </div>
                <div class="col-lg-4 col-12">
                    <div class="td-sidebar">
                        <div class="widget widget_search">  
                            <h4 class="widget-title">Search Keyword</h4>         
                            <form class="search-form">
                                <div class="form-group">
                                    <input type="text" placeholder="Key word">
                                </div>
                                <button class="submit-btn" type="submit"><i class="fa fa-search"></i></button>
                            </form>
                        </div> 
                        <div class="widget widget_catagory">
                            <h4 class="widget-title">Catagory</h4>                                 
                            <ul class="catagory-items">
                                <li><a href="blog.html">Digital marketing</a></li>
                                <li><a href="blog.html">Machine learning</a></li>
                                <li><a href="blog.html">It management</a></li>
                                <li><a href="blog.html">PLM Data Migration</a></li>
                                <li><a href="blog.html">Web Design</a></li>
                                <li><a href="blog.html">Supply Chain</a></li>
                                <li><a href="blog.html">IT Consultancy</a></li>
                            </ul>
                        </div>                  
                        <div class="widget widget-recent-post">                            
                            <h4 class="widget-title">Recent News</h4>
                            <ul>
                                <li>
                                    <div class="media">
                                        <div class="media-left">
                                            <img src="assets/img/widget/1.webp" alt="blog">
                                        </div>
                                        <div class="media-body align-self-center">
                                            <h6 class="title"><a href="#">Business Organisation.</a></h6>
                                            <div class="post-info"><i class="far fa-calendar-alt"></i><span>15 October</span></div>                     
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="media">
                                        <div class="media-left">
                                            <img src="assets/img/widget/2.webp" alt="blog">
                                        </div>
                                        <div class="media-body align-self-center">
                                            <h6 class="title"><a href="#">Data Security</a></h6>
                                            <div class="post-info"><i class="far fa-calendar-alt"></i><span>15 October</span></div>                      
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="media">
                                        <div class="media-left">
                                            <img src="assets/img/widget/3.webp" alt="blog">
                                        </div>
                                        <div class="media-body align-self-center">
                                            <h6 class="title"><a href="#">Cloud and Business IT</a></h6>
                                            <div class="post-info"><i class="far fa-calendar-alt"></i><span>15 October</span></div>                      
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="widget widget_tag_cloud mb-0">
                            <h4 class="widget-title">Tags</h4>
                            <div class="tagcloud">
                                <a href="#">Marketing</a>
                                <a href="#">Learn</a>
                                <a href="#">Business</a>
                                <a href="#">Portfolio</a>
                                <a href="#">Project</a>
                                <a href="#">Art</a>
                                <a href="#">Personal</a>
                                <a href="#">Landing</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- blog area end -->
</template>

<script>
    export default {
        name: 'Blog'
    }
</script>